import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { toMoneyFormat } from 'utils';

import { WidgetContainer } from 'components';
import Box from '@material-ui/core/Box';
import SunIcon from 'components/icons/sun-icon';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  totalBalance: number | null;
}

const FinanceWidget: React.FC<Props> = ({ totalBalance }) => {
  const classes = useStyles();
  const history = useHistory();

  const forwardToBalancePage = () => {
    history.push('/balance');
  };

  const isTotalBalance = totalBalance !== null;

  return (
    <WidgetContainer
      themeColor="darkBlue"
      title={isTotalBalance ? 'Maksuerittely' : undefined}
      action={isTotalBalance ? forwardToBalancePage : undefined}
    >
      <Box padding="15px">
        <h3 className={classes.title}>Maksutilanne</h3>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent={isTotalBalance ? 'space-between' : 'center'}
        padding="15px"
        paddingTop={0}
        height="100%"
      >
        <Box display="flex" alignItems="center">
          <SunIcon className={classes.sunIcon} />
          <span className={classes.text}>
            {isTotalBalance
              ? 'Maksujesi kokonaistilanne:'
              : 'Sinulla ei ole vielä erääntyneitä laskuja yhtiöltä.'}
          </span>
        </Box>
        {totalBalance !== null ? (
          <div
            className={clsx(classes.balanceBox, {
              [classes.green]: totalBalance === 0 || totalBalance > 0,
              [classes.red]: totalBalance < 0,
            })}
          >
            {totalBalance === 0 && 'Ei avoimia laskuja'}
            {totalBalance > 0 &&
              `Ennakkomaksua ${toMoneyFormat(totalBalance)} €`}
            {totalBalance < 0 &&
              `Erääntyneitä maksuja ${toMoneyFormat(totalBalance)} €`}
          </div>
        ) : null}
      </Box>
    </WidgetContainer>
  );
};

export default memo(FinanceWidget);
